export default __webpack_public_path__ + "static/media/SEC1710.34I-41018_-24372_0.ee6c5019.jpg";